import * as React from 'react'
import { createAction } from 'redux-api-middleware'
import { HUBBLE_API_TOKEN } from '../store/middleware/APIUrl'
import { useAppDispatch } from './types'

const ActionTypes = {
    SAVE_TABLE_COLUMNS: 'SAVE_TABLE_COLUMNS',
    SELECT_ESTATE: 'SELECT_ESTATE',
    DASHBOARD_STATS_FETCH_REQUEST: 'DASHBOARD_STATS_FETCH##REQUEST',
    DASHBOARD_STATS_FETCH_SUCCESS: 'DASHBOARD_STATS_FETCH##SUCCESS',
    DASHBOARD_STATS_FETCH_FAILURE: 'DASHBOARD_STATS_FETCH##FAILURE',
    CLEAR_UPLOAD_PROGRESS: 'CLEAR_UPLOAD_PROGRESS',
    SAVE_UPLOAD_PROGRESS: 'SAVE_UPLOAD_PROGRESS',
}

/**
 * @deprecated Use ActionTypes instead
 */
export const Types = ActionTypes

function selectEstate(estateId, withRedirection = false) {
    return (dispatch, getState) => {
        const { router } = getState()
        const { location } = router || {}
        const { pathname } = location || {}

        const splittedPathname = pathname.split('/')
        splittedPathname[0] = estateId
        const newPathname = `/${splittedPathname.join('/')}`

        const estateChangeResult = dispatch({
            type: ActionTypes.SELECT_ESTATE,
            payload: { estateId },
            meta: { pathname },
        })

        if (!withRedirection) {
            return estateChangeResult
        }

        return dispatch({
            type: '@@router/LOCATION_CHANGE',
            payload: {
                location: {
                    pathname: newPathname,
                    search: '',
                    hash: '',
                },
                action: 'PUSH',
            },
        })
    }
}

function keepSessionAlive(value) {
    return {
        type: 'KEEP_SESSION_ALIVE',
        payload: { value },
    }
}

function resize(width, height) {
    return {
        type: 'WINDOW_RESIZE',
        payload: { width, height },
    }
}

function fetchDashboardStats() {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/dashboard`,
        method: 'GET',
        types: [ActionTypes.DASHBOARD_STATS_FETCH_REQUEST, ActionTypes.DASHBOARD_STATS_FETCH_SUCCESS, ActionTypes.DASHBOARD_STATS_FETCH_FAILURE],
    })
}

function saveTableColumns(tableKey, columns = []) {
    return {
        type: ActionTypes.SAVE_TABLE_COLUMNS,
        payload: {
            columns,
            tableKey,
        },
    }
}

/**
 * Save current progress for a current
 * @param {Number} progress
 * @returns
 */
function saveUploadProgress(progress, currentfileName) {
    return {
        type: ActionTypes.SAVE_UPLOAD_PROGRESS,
        payload: { progress, currentfileName },
    }
}

/**
 * We delete the current progress to indicate there is no upload running
 * @returns
 */
function clearUploadProgress() {
    return {
        type: ActionTypes.CLEAR_UPLOAD_PROGRESS,
    }
}

function changePageTitle(section = '') {
    const title = section
        ? `Hubble CMS - ${section}`
        : 'Hubble CMS'

    document.title = title

    return {
        type: ActionTypes.CLEAR_UPLOAD_PROGRESS,
        payload: { title },
    }
}

function usePageTitle(section = '') {
    const dispatch = useAppDispatch()
    React.useEffect(() => {
        dispatch(changePageTitle(section))
    }, [section, dispatch])
}

export {
    ActionTypes,
    changePageTitle,
    clearUploadProgress,
    fetchDashboardStats,
    keepSessionAlive,
    resize,
    saveTableColumns,
    saveUploadProgress,
    selectEstate,
    usePageTitle,
}
